import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, MessageCircle, ArrowUpRight } from 'lucide-react';
import { fadeUp, staggerContainer, viewport } from '../../lib/motion';
import { waLink } from '../../lib/whatsapp';

export default function Contact() {
  const contactItems = [
    { icon: Mail, label: 'Email Us', value: 'accohyd768@gmail.com', testid: 'contact-email-text' },
    { icon: Phone, label: 'Call Us', value: '+91 99127 40286', testid: 'contact-phone-text' },
    { icon: MapPin, label: 'Visit Us', value: 'Datta Sai Commercial Complex, 2nd Floor, Room 204-A, Block-A, RTC X Roads, Hyderabad 500020', testid: 'contact-address-text' },
  ];

  return (
    <section id="contact" className="px-6 lg:px-10 py-28 bg-ink-800">
      <div className="max-w-6xl mx-auto bg-gradient-to-br from-ink-700 to-ink-900 border border-slate-800 rounded-[2rem] p-8 lg:p-16 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
        <motion.div variants={staggerContainer()} initial="hidden" whileInView="show" viewport={viewport} className="space-y-8">
          <div>
            <motion.span variants={fadeUp} className="text-xs tracking-[0.2em] uppercase font-semibold text-gold-light">Get in Touch</motion.span>
            <motion.h2 variants={fadeUp} className="font-display text-4xl sm:text-5xl text-white tracking-tight mt-3">Talk to us on WhatsApp</motion.h2>
            <motion.p variants={fadeUp} className="text-slate-400 mt-4 leading-relaxed">Have questions about our tax advisory or accounting services? Message us on WhatsApp and get a fast, personal response from our team.</motion.p>
          </div>

          <div className="space-y-5">
            {contactItems.map((c) => (
              <motion.div variants={fadeUp} key={c.label} className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-xl bg-gold/10 border border-gold/20 flex items-center justify-center text-gold-light shrink-0">
                  <c.icon className="w-5 h-5" strokeWidth={1.5} />
                </div>
                <div>
                  <span className="block text-xs text-slate-400">{c.label}</span>
                  <span className="text-white font-medium text-sm" data-testid={c.testid}>{c.value}</span>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} className="flex justify-center">
          <div className="relative bg-ink-900 border border-slate-800 rounded-3xl p-10 text-center w-full max-w-md shadow-2xl">
            <div className="w-20 h-20 rounded-2xl bg-[#25D366]/15 border border-[#25D366]/30 flex items-center justify-center mx-auto text-[#25D366] mb-6">
              <MessageCircle className="w-10 h-10" strokeWidth={1.5} />
            </div>
            <h3 className="font-display text-2xl text-white">Chat with SN Associates</h3>
            <p className="text-sm text-slate-400 mt-3 mb-8">Tap below to start a WhatsApp conversation — we typically reply within a couple of business hours.</p>
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp-cta"
              className="group w-full flex items-center justify-center gap-2.5 py-4 rounded-full bg-[#25D366] hover:bg-[#20bd5a] text-white font-semibold text-sm transition-colors shadow-[0_0_20px_rgba(37,211,102,0.4)]"
            >
              <MessageCircle className="w-5 h-5" strokeWidth={1.5} /> Chat on WhatsApp
              <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" strokeWidth={1.5} />
            </a>
            <p className="text-xs text-slate-600 mt-5">+91 99127 40286</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
